import React from "react";
import { Route } from "react-router";
import MenuPage from "./MenuPage";

const RouterMenus = () => {
  return <Route exact path="/menus/:id?" name="Board" component={MenuPage} />;
};

export default RouterMenus;
